import { Link } from 'react-router-dom'

/** Equivalent of legacy `PaymentCancelComponent` (current `/payment/cancel`). */
export function PaymentCancelPage() {
  return (
    <div className="screener-card screener-card--notice">
      <h1>Payment cancelled</h1>
      <p>Your payment was not completed.</p>
      <Link to="/payment">Back to payment overview</Link>
    </div>
  )
}
